import { combineReducers } from 'redux';
import storage from 'redux-persist/lib/storage';

import { LOGOUT_USER } from 'redux/actionTypes';
import activeUserId from 'redux/reducers/activeUserId';
import activeUserType from 'redux/reducers/activeUserType';
import authToken from 'redux/reducers/authToken';
import user from 'redux/reducers/user';
import customers from 'redux/reducers/customers';
import products from 'redux/reducers/products';
import categories from 'redux/reducers/categories';
import employees from 'redux/reducers/employees';
import vendors from 'redux/reducers/vendors';
import salesOrders from 'redux/reducers/salesOrders';
import processes from 'redux/reducers/processes';
import expenses from 'redux/reducers/expenses';
//import expenseTypes from 'redux/reducers/expenseTypes';
//import fundTransfers from 'redux/reducers/fundTransfers';
import newSalesOrder from 'redux/reducers/newSalesOrder';
import idGen from 'redux/reducers/idGen';
import failedLogin from 'redux/reducers/failedLogin';

const appReducer = combineReducers({
    activeUserId,
    activeUserType,
    authToken,
    user,
    customers,
    products,
    categories,
    employees,
    vendors,
    salesOrders,
    processes,
    expenses,
    //expenseTypes,
    //fundTransfers,
    newSalesOrder,
    idGen,
    failedLogin
});

export const rootReducer = (state, action) => {
    if(action.type === LOGOUT_USER) {

        storage.removeItem('persist: root')

        state = undefined;
    }

    return appReducer(state, action)
};